import React, { Component } from 'react';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import AdminLoginPage from './login/AdminLoginPage';
import AdminDashboard from './dashboard/AdminDashboard';
import AdminCustomers from './customers/AdminCustomers';
import AdminCustomerDetail from './customers/AdminCustomerDetail';
import AdminProducts from './products/AdminProducts';
import AdminCollections from './collections/AdminCollections';
import AdminAdmins from './admins/AdminAdmins';
import AdminSupportRequests from './support/AdminSupportRequests';
import { openAuthView } from '../../modules/auth';

class AdminRouter extends Component {
  componentDidMount() {
    const { authViewVisible, openAuthView: showAuthView } = this.props;
    if (!authViewVisible) {
      showAuthView('login');
    }
  }

  render() {
    const { admin, location } = this.props;
    const adminUser = admin && admin.user;
    const adminToken = admin && admin.token;
    const isAuthenticatedAdmin = Boolean(adminUser && adminToken);

    if (!isAuthenticatedAdmin) {
      if (location.pathname !== '/admin/login') {
        return <Redirect to="/admin/login" />;
      }
      return (
        <Switch>
          <Route path="/admin/login" component={AdminLoginPage} exact />
        </Switch>
      );
    }

    if (location.pathname === '/admin/login') {
      return <Redirect to="/admin" />;
    }

    if (location.pathname === '/admin/admins' && adminUser.type !== 'superadmin') {
      return <Redirect to="/admin" />;
    }

    return (
      <Switch>
        <Route path="/admin/customers/:userId" component={AdminCustomerDetail} exact />
        <Route path="/admin/customers" component={AdminCustomers} exact />
        <Route path="/admin/templates" component={AdminCollections} exact />
        <Route path="/admin/collections" render={() => <Redirect to="/admin/templates" />} exact />
        <Route path="/admin/products" component={AdminProducts} exact />
        <Route path="/admin/support" component={AdminSupportRequests} exact />
        <Route path="/admin/admins" component={AdminAdmins} exact />
        <Route path="/admin" component={AdminDashboard} />
      </Switch>
    );
  }
}

AdminRouter.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  admin: PropTypes.shape({
    user: PropTypes.shape({
      roles: PropTypes.arrayOf(PropTypes.string),
      type: PropTypes.string,
    }),
    token: PropTypes.string,
  }),
  authViewVisible: PropTypes.bool.isRequired,
  openAuthView: PropTypes.func.isRequired,
};

AdminRouter.defaultProps = {
  admin: null,
};

const mapStateToProps = (state) => ({
  admin: state.auth.admin,
  authViewVisible: state.auth.authViewVisible,
});

const mapDispatchToProps = {
  openAuthView,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AdminRouter));
